export interface IReleaseSection {
  title: string;
  items: string[];
}

export interface IRelease {
  version: string;
  date: string;
  sections: IReleaseSection[];
}

// Newest first. The first entry is the current version shown on the Home page.
export const releaseNotes: IRelease[] = [
  {
    version: '1.9',
    date: '2026-10-07',
    sections: [
      {
        title: 'Calendar page',
        items: [
          'The top of the page is reorganised into three labelled rows: Internal Name, Year, Vendor, Private/Shared, Status and Delete; Owner and Notes; Product Id, Product Name, Tagline, EAN and PDF.',
          "Internal Name (the calendar's name) and the printed Title layout item are now independent; editing one no longer changes the other.",
          'Year is edited on this page only and also updates the Year layout item (shown read-only in the layout list).',
          'Delete moved here from the Images view and asks for confirmation.',
          'The linked product refreshes automatically when Internal Name, Year or the Tagline changes (the REFRESH button is gone).',
          'Product Id links to the product page; EAN links to its barcode page.',
          'PDF: a PDF label with a Preview button; once generated, the file link (file name only) with a refresh button. The form is faded and disabled while a preview generates.',
          'New IMAGES button opens the calendar in the Images view.',
          'Opening a calendar that no longer exists returns to the Calendars list.',
        ],
      },
      {
        title: 'Images (search) view',
        items: [
          'The selected-calendar header is read-only: title and year in bold, status and Private/Shared as icons (names as tooltips), the owner in brackets, and an Edit button; status also shows when the header is collapsed. It is faded when no calendar is selected.',
          'The calendar year filter defaults to the same year as New Calendar, and on load your first calendar for that year is selected (or none).',
          'After creating a calendar, the year filter and search text reset so it is visible.',
          'Include Shared is one setting shared by the Images and Calendars pages.',
          'New Calendar and New Collection no longer accept a blank name.',
        ],
      },
      {
        title: 'Everywhere',
        items: [
          'The sync status icon in the header is a button that refreshes all data, from any view.',
          'Signing in returns to the site you came from (including localhost for development).',
        ],
      },
      {
        title: 'API (requires the API update)',
        items: [
          "Editing the Title layout item no longer overwrites the calendar's Internal Name.",
          'Deleting a calendar now works (it removes its images and layout items too).',
          'A missing calendar returns 404 instead of a server error.',
        ],
      },
      {
        title: 'Data',
        items: ['Calendars whose Year or Title were out of step with their layout items were corrected.'],
      },
      {
        title: 'Coming next',
        items: ['API authentication, CORS headers on error responses, a route guard for deep links, and Search view layout presets.'],
      },
    ],
  },
];

export const currentVersion = releaseNotes[0].version;
